// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import { sync } from 'vuex-router-sync'
import Vue from 'vue'
import Vuex from 'vuex'
import VueResource from 'vue-resource'
import VueRouter from 'vue-router'
import App from './App'
import routes from './router'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import store from './store/store'
import VueQrcodeReader from 'vue-qrcode-reader'
// import colors from 'vuetify/es5/util/colors'

window.addEventListener('online', function(e) {
  store.dispatch('syncTickets')
})

Vue.use(Vuetify, {
  theme: {
    primary: '#005D8A'
  }
})
Vue.use(Vuex)
Vue.use(VueResource)
Vue.use(VueRouter)
Vue.use(VueQrcodeReader)

Vue.config.productionTip = false
Vue.http.options.root = process.env.SERVER
const hostname = window.location.hostname
let documentApp = 'Checkin'
if (hostname.includes('swap') || hostname.includes('troca')) {
  Vue.http.headers.common['Validation'] = 'swap'
  documentApp = process.env.DOCUMENT_APP
}
document.title = `${process.env.DOCUMENT_TITLE} | ${documentApp}`

Vue.http.headers.common['Access-Control-Allow-Credentials'] = 'true'
Vue.http.headers.common['Accept'] = 'application/json, text/plain, */*'

const router = new VueRouter({ routes, mode: 'history' })

store.dispatch('loadEventFromLocalStore')
store.dispatch('loadProductsFromLocalStore')
store.dispatch('loadTicketsFromLocalStore')
store.dispatch('loadTicketsReadedFromLocalStore')

router.beforeEach((to, from, next) => {
  store.dispatch('tryAutoLogin')
  const userId = store.getters.userId
  if ((userId === null || userId === 0) && to.path !== '/login') {
    next('/login')
  } else {
    const selectedEvent = store.getters.selectedEvent
    if (!selectedEvent.id && to.path === '/') {
      store.dispatch('setSnackbarColor', 'error')
      store.dispatch('setSnackbarMessage', 'Selecione um evento')
      store.dispatch('setSnackbarOpen', true)
      next('/events')
    } else {
      next()
    }
  }
})

sync(store, router)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js